/**
 * This file is used for displaying a stylized checkbox.
 * Internally, it relies on a native checkbox so as to behave has a regular one.
 * This should allow it to be used in forms like and potentially help with accessibility.
 */

import type {TemplateResult} from 'lit';
import {html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {classMap} from 'lit/directives/class-map.js';

@customElement('element-line-checkbox')
export class ElementLineCheckbox extends LitElement {
  @property({type: Boolean})
  bodyLinksTextFont = true;

  @property({type: Boolean})
  checked = false;

  @property({type: String})
  name = '';

  @property({type: Object})
  label: () => string | TemplateResult | undefined;

  @property({type: Boolean})
  checkboxFirst = false;

  @property({type: Boolean})
  sign = false;

  override render() {
    return html` <label
      data-cy="${this.name}"
      tabindex="0"
      class="${classMap({
        'text-focused-red': this.checked,
        'flex-row-reverse': this.checkboxFirst,
        'justify-end': this.checkboxFirst,
        'justify-between': !this.checkboxFirst,
        'mouse:hover:bg-page-main': !this.sign,
        'px-[12px]': !this.sign,
        'py-[9px]': !this.sign,
        'body-links-and-text': this.bodyLinksTextFont,
        body: !this.bodyLinksTextFont,
      })} relative flex cursor-pointer
          select-none"
      >${this.label()}<input
        tabindex="-1"
        class="${classMap({
          sign: this.sign,
          'mr-[12px]': this.checkboxFirst,
        })} w-0 opacity-0"
        type="checkbox"
        name=${this.name}
        .checked=${this.checked}
      /><span
        class="${classMap({
          'lg:mt-[8px]': !this.bodyLinksTextFont,
        })} mt-[2px] md:mt-[5px]"
      ></span>
    </label>`;
  }

  override createRenderRoot() {
    return this;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'element-line-checkbox': ElementLineCheckbox;
  }
}
